import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import EnhancedTable from './table/EnhancedTable';
import SentByMeDrawer from './drawer/SentByMeDrawer';
import { Title } from '../../style';

/**
 * Composant principale englobant toute la section expéditions
 */
const SentByMe = () => (
  <div>
    <Grid container spacing={10}>
      <Grid item md={3}>
        <Title>Expéditions</Title>
      </Grid>
    </Grid>
    <SentByMeDrawer />
    <EnhancedTable />
  </div>
);

SentByMe.propTypes = {};

export default connect(null, null)(SentByMe);
